import { render } from "./article_listing_layout.vue?vue&type=template&id=5fff638f"
import script from "./article_listing_layout.vue?vue&type=script&lang=js"
export * from "./article_listing_layout.vue?vue&type=script&lang=js"

import exportComponent from "/home/thedrago/public_html/NewSite2023/wp-content/themes/chop-child/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/components/article_listing_layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fff638f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fff638f', __exports__)) {
    api.reload('5fff638f', __exports__)
  }
  
  module.hot.accept("./article_listing_layout.vue?vue&type=template&id=5fff638f", () => {
    api.rerender('5fff638f', render)
  })

}


export default __exports__